module.exports = __webpack_public_path__ + "static/media/icon-camara.0dc50395.svg";